import { Injectable } from '@angular/core';

import { MenuItem } from './menu-item.model';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    constructor() {}

    public getMenuItems(items: any): MenuItem[] {
        const menuItems = [];

        for (const itemName in items) {
            if (items.hasOwnProperty(itemName)) {
                const item = { ...items[itemName] };

                if (item.children) {
                    item.children = this.getMenuItems(item.children);

                    if (item.children.length === 0) {
                        continue;
                    }
                }

                menuItems.push(item);
            }
        }

        return menuItems;
    }
}
